import {topUpLogList} from 'api/topUpLog';
import Cookies from 'js-cookie';

const topUpLog = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        topUpLogList({commit},params) {
            return new Promise((resolve, reject) => {
                var startTime = params.startTime;
                var endTime = params.endTime;
                var accountBegin = params.accountBegin;
                var accountEnd = params.accountEnd;
                var agent = params.agent;
                var productId = params.productId;
                var type = params.type;
                var status = params.status;
                var psize = params.psize;
                var currentPage = params.currentPage;
                topUpLogList(startTime,endTime,accountBegin,accountEnd,agent,productId,type,status,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default topUpLog;



// WEBPACK FOOTER //
// ./src/store/modules/topUpLog.js